import React, { useState } from "react";
import { Stack } from "@mui/material";
import {
  GoodDistributionInput,
  GoodInput,
  ShipmentLocationType,
} from "../../../../graphql/generated";
import {
  FormError,
  ShipmentLocationInputData,
} from "../../../../redux/slices/Types";
import ShipmentLocationForm from "../ShipmentLocationForm";
import ReceiverGoodsListContainer from "../ReceiverGoodsList";
import ReceiverGoodsListModal from "../ReceiverGoodsList/ReceiverGoodsListModal";

export type ReceiverFormProps = {
  shipmentLocation: ShipmentLocationInputData;
  shippedGoods: Array<GoodInput>;
  receivedGoods: Array<GoodDistributionInput>;
  inline?: boolean;
  allowAddressLocation?: boolean;
  errors?: FormError;
  onChange: (receiver: ShipmentLocationInputData) => void;
  onReceivedGoodsChange?: (receivedGoods: Array<GoodDistributionInput>) => void;
  allowNewLocation?: boolean;
};

export default function ReceiverForm({
  shipmentLocation,
  shippedGoods,
  receivedGoods,
  inline = false,
  allowAddressLocation = true,
  errors,
  onChange,
  onReceivedGoodsChange,
  allowNewLocation = true,
}: ReceiverFormProps) {
  // Prefer a partial received-goods update so we never overwrite fields (like
  // the defaulted delivery window) with a stale location snapshot.
  const handleReceivedGoodsChange = (
    receivedGoods: Array<GoodDistributionInput>
  ) => {
    if (onReceivedGoodsChange) {
      onReceivedGoodsChange(receivedGoods);
    } else {
      onChange({ ...shipmentLocation, receivedGoods });
    }
  };
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleOpen = () => setOpenModal(true);

  const closeGoodsModal = () => {
    setOpenModal(false);
  };

  return (
    <Stack spacing={5}>
      <ShipmentLocationForm
        locationType={ShipmentLocationType.DropOff}
        shippedGoods={shippedGoods || []}
        data={shipmentLocation}
        onChange={onChange}
        onGoodsOpen={handleOpen}
        errors={errors}
        locationOnly={inline}
        allowAddressLocation={allowAddressLocation}
        renderAfterLocationSelect={() => {
          if (!inline) {
            return null;
          }
          if (!shipmentLocation.receiver) {
            return null;
          }
          return (
            <ReceiverGoodsListContainer
              onChange={handleReceivedGoodsChange}
              shippedGoods={shippedGoods}
              receivedGoods={receivedGoods}
              shipmentLocation={{
                ...shipmentLocation,
                receivedGoods: shipmentLocation.receivedGoods,
                persistedReceivedGoods: shipmentLocation.receivedGoods,
              }}
              inlineShipperSelection={true}
            />
          );
        }}
        allowNewLocation={allowNewLocation}
      />
      {inline ? null : (
        <ReceiverGoodsListModal
          shippedGoods={shippedGoods || []}
          receivedGoods={receivedGoods || []}
          shipmentLocation={shipmentLocation}
          width="md"
          openModal={openModal}
          onClose={closeGoodsModal}
          onChange={handleReceivedGoodsChange}
        />
      )}
    </Stack>
  );
}
